export default Object.freeze({
  "NOT_LOADED": "NOT_LOADED",
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  FAILED: 'FAILED'
});
